import type { ILogService, IScope } from "angular";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IWidgetComponentController } from "../IWidgetComponentController";

export class SitesListWidgetComponentController implements IWidgetComponentController {
    public static $inject = ["$log", "$scope", "sitesRepository"];

    public icon: string;

    public caption: string;

    public subCaption: string = null;

    public url: string;

    public isLoading: boolean;

    public sites: any[];

    constructor(private $log: ILogService, private $scope: IScope, private sitesRepository: ISitesRepository) {
        this.icon = "building";
        this.caption = "All of my favorite sites";

        this.url = "#/sites";

        this.isLoading = true;

        setTimeout(() => {
            this.sitesRepository.getSites().subscribe((sites: any) => {
                this.$scope.$applyAsync(() => {
                    const numSites = sites.length;
                    this.sites = sites;
                    // return $translate("Entities.Site.NumActiveSitesFormat", { numSites}, "messageformat");
                    this.subCaption = `${numSites} sites`;
                    // }).then((subCaption: any) => {
                    //    this.subCaption = subCaption;
                    this.isLoading = false;
                });
            });
        }, 1000);
    }
}
